module.exports = __webpack_public_path__ + "static/img/phone_afsc_icon.077944f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_afsc_icon.jpg
// module id = pZLs
// module chunks = 1